<template>
	<div class="other_page_r">
		<el-card class="card_box">
			<div slot="header" class="card_title">
				<span>信息审核</span>
			</div>
			<div>
				<el-form :inline="true" :model="searchInfo" class="demo-form-inline">
					<el-form-item label="类型">
						<el-select
							class="custom_input_170"
							v-model="searchInfo.type"
							placeholder=""
						>
							<el-option label="文章" value="1"></el-option>
							<el-option label="专栏" value="5"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="审核状态" v-if="searchInfo.type == 5">
						<el-select
							class="custom_input_170"
							v-model="searchInfo.examine_type"
							placeholder=""
						>
							<el-option label="通过" value="1"></el-option>
							<el-option label="审核中" value="2"></el-option>
							<el-option label="拒绝" value="3"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item>
						<el-button type="primary" @click="searchBtn">查询</el-button>
						<el-button type="primary" @click="reset()">重置</el-button>
					</el-form-item>
				</el-form>
			</div>

			<div class="table_box">
				<tablec :tableData="tableData" v-if="type == 5"></tablec>
				<tablec1 :tableData="tableData" v-else></tablec1>
			</div>
			<div
				class="flex justify_content_e aligin_items_c table_footer custom_btn"
			>
				<div>
					<pagination
						v-show="total > 0"
						:total="total"
						:page.sync="searchInfo.page"
						:limit.sync="searchInfo.size"
						@pagination="getDataList"
					/>
				</div>
			</div>
		</el-card>
	</div>
</template>

<script>
import tablec from "./tablec.vue";
import tablec1 from "./tablec1.vue";
import { authColumnList } from "@/api/examine";
import { getInformationList, getCategoryList } from "@/api/article";
import { searchMixin } from "@/utils/searchMixin.js";
export default {
	mixins: [searchMixin],
	components: { tablec, tablec1 },
	name: "",
	data() {
		return {
			tableData: [],
			total: 0,
			categoryList: [],
			type: "",
			searchInfo: {
				examine_type: "2",
				page: 1,
				size: 10,
				type: "5",
				status: "0",
				source_id: "1024",
			},
		};
	},
	created() {
		let _obj = JSON.parse(sessionStorage.getItem("messageListKey_examine2"));
		if (_obj) {
			Object.keys(this.searchInfo).forEach((key) => {
				this.searchInfo[key] = _obj[key] || this.searchInfo[key];
			});
		}
		this.getDataList();
		this.getCategoryListFun();
	},
	methods: {
		getCategoryListFun() {
			getCategoryList({})
				.then((res) => {
					if (res.code == 200) {
						this.categoryList = res.data.data;
					} else {
						this.categoryList = [];
					}
				})
				.catch((error) => {
					this.$message.error(error.message);
				});
		},
		searchBtn() {
			this.searchInfo.page = 1;
			this.getDataList();
		},
		getDataList() {
			let _data = Object.assign(this.searchInfo, {});
			sessionStorage.setItem("messageListKey_examine2", JSON.stringify(_data));
			const that = this;
			var searchData = {
				title: this.searchInfo.title,
				category_id: this.searchInfo.category_id,
				examine_type:
					this.searchInfo.examine_type == ""
						? 99
						: this.searchInfo.examine_type,
				page: this.searchInfo.page,
				size: this.searchInfo.size,
				type: 5,
				source_id: "1024",
			};
			if (this.searchInfo.type == 1) {
				searchData = {};
				searchData = {
					page: this.searchInfo.page,
					size: this.searchInfo.size,
					type: this.searchInfo.type,
					status: 0,
					source_type: 10001,
				};
			}
			getInformationList(searchData)
				.then((res) => {
					if (res.code == 200) {
						this.type = this.searchInfo.type;
						that.tableData = res.data.data;
						that.total = res.data.total;
					} else {
						that.tableData = [];
						that.total = 0;
					}
					this.loading = false;
				})
				.catch((error) => {
					this.$message.error(error.message);
				});
		},
		reset() {
			this.searchInfo = {
				examine_type: "2",
				page: 1,
				size: 10,
				type: "5",
				status: "0",
				source_id: "1024",
			};
		},
	},
};
</script>

<style scoped></style>
